import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

export const CreatingClaim: React.FC = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '400px',
        gap: 3,
      }}
    >
      <CircularProgress size={48} />
      <Box sx={{ textAlign: 'center' }}>
        <Typography variant="h6" gutterBottom>
          Creating Claim
        </Typography>
        <Typography variant="body2" color="text.secondary">
          We are getting your claim set up. We&apos;ll pre-populate information where we have it and recommend the billing codes based on your session data.
        </Typography>
      </Box>
    </Box>
  );
};
